import React, {useEffect, useState} from 'react';
import s from "./EmailAuntification.module.css";
import MyBtn from "../../ui/MyBtn/MyBtn";
import {useFormik} from "formik";
import {motion} from 'framer-motion';
import {loginVereficationThunk} from "../../../store/reducers/ActionCreators";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import ErrorModal from "../../ui/ErrorModal";
import SuccessModal from "../../ui/SuccessModal";
import MyInput from "../../ui/MyInput/MyInput";
import {useNavigate} from "react-router-dom";
import {zeroFill} from "../../../helpers/ZeroFill";
import {setDisabled, userSlice} from "../../../store/reducers/UserSlice";

export type EmailVereficationDataType = {
    email: string | null,
    code: string
}

const EmailAuntification = (props: any) => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const userEmail = useAppSelector(state => state.userReducer.user.userData.email)
    const registrationWasSuccess = useAppSelector(state => state.userReducer.registrationWasSuccess)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [isRegistrationSuccessModalOpen, setIsRegistrationSuccessModalOpen] = useState(false);

    let timer: string | number | NodeJS.Timeout | undefined
    const startTimer = () => {
        timer = setTimeout(() => navigate('/login'), 6000);
    }

    useEffect(() => {
        return clearTimeout(timer)
    }, [timer])

    useEffect(() => {
        // Show registration success modal only if user just completed registration
        if (registrationWasSuccess) {
            setIsRegistrationSuccessModalOpen(true);
            // Reset the registration success state so modal doesn't show again
            dispatch(userSlice.actions.setRegistrationWasSuccess(false));
        }
    }, [registrationWasSuccess, dispatch])

    const formikLogin = useFormik({
        initialValues: {
            email: userEmail,
            code: '',
        },
        onSubmit: values => {
            dispatch(loginVereficationThunk(values))
                .then(() => {
                    setIsSuccessModalOpen(true)
                    startTimer()
                })
                .catch(() => {
                    setIsErrorModalOpen(true)
                })
                .finally(() => {
                    dispatch(setDisabled(false))
                })
        }
    })

    const [time, setTime] = useState(120)
    const [timeIsOver, setTimeIsOver] = useState(false)

    const tick = () => {
        if (time === 0) {
            setTimeIsOver(true)
            navigate("/login")
            return
        }
        setTime(prevState => prevState - 1)
    }
    const minutes = Math.floor(time / 60);
    const seconds = time - minutes * 60;

    React.useEffect(() => {
        const timerID = setInterval(() => tick(), 1000);
        return () => clearInterval(timerID);
    });

    const closeAndRedirect = () => {
        setIsSuccessModalOpen(false)
        navigate("/login")
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >

            <SuccessModal
                isOpen={isRegistrationSuccessModalOpen}
                onClose={() => setIsRegistrationSuccessModalOpen(false)}
                title="Registration Successful!"
                message="Your account has been created successfully. Please check your email inbox for a verification code to complete the registration process."
            />

            <SuccessModal
                isOpen={isSuccessModalOpen}
                onClose={closeAndRedirect}
                message="Registration completed successfully. In a few seconds you will be redirected to the login page."
            />

            <ErrorModal
                isOpen={isErrorModalOpen}
                onClose={() => setIsErrorModalOpen(false)}
                message="The email verification code is incorrect. Please check and try again."
            />

            <div className={s.sign_in_wrapper}>
                <form onSubmit={formikLogin.handleSubmit}>
                    <div className={s.sign_in_content}>
                        <div className={s.title}>
                            Email confirmation
                        </div>
                        <div className={s.subtitle}>
                            The password was sent to your email address
                        </div>
                        <div className={s.input_block}>
                            <div className={s.input_label}>
                                confirmation Code
                            </div>
                            <MyInput
                                id="code"
                                name="code"
                                value={formikLogin.values.code}
                                onChange={formikLogin.handleChange}
                                placeholder={"6 digits"}
                            />
                        </div>
                        <div className={s.timer_wrapper}>
                            {timeIsOver
                                ? <div></div>
                                : <div> {zeroFill(minutes, 2)} : {zeroFill(seconds, 2)}</div>
                            }
                        </div>
                        <div className={s.btn_block}>
                            <MyBtn title={"Authentication"} type={"submit"}/>
                        </div>
                    </div>
                    {/*<div className={s.dont_have_account}>*/}
                    {/*    <div>*/}
                    {/*        Back to*/}
                    {/*    </div>*/}
                    {/*    <Link className={s.link} to={"#"}>Sign up</Link>*/}
                    {/*</div>*/}
                </form>
            </div>
        </motion.div>
    );
};

export default EmailAuntification;
